import { MatSelect } from '@angular/material/select';
import { map } from 'lodash';
import { debounceTime, distinctUntilChanged, pairwise } from 'rxjs/operators';
import { CommonUtilsService } from './../shared/common-utils.service';
import { ControlsBaseComponent } from './../shared/components/controls-base.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Config } from '../models/ui-config';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { JsonDynamicComponentService } from '../json-dynamic-component.service';

@Component({
  selector: 'ra-boolean-dropdown-control',
  templateUrl: './boolean-dropdown-control.component.html',
  styleUrls: ['./boolean-dropdown-control.component.scss'],
  standalone: false,
})
export class BooleanDropdownControlComponent
  extends ControlsBaseComponent
  implements OnInit
{
  static nextId = 0;
  tempFormGroup = new FormGroup({
    value: new FormControl(null),
  });
  id;
  @ViewChild('matSelect') matSelect: MatSelect;

  constructor(
    protected jsonDynamicComponentService: JsonDynamicComponentService,
    protected commonUtils: CommonUtilsService,
  ) {
    super(jsonDynamicComponentService, commonUtils);
    this.id = CommonUtilsService.createGUID();
  }

  ngOnInit() {
    if (this.currentConfig?.validators?.required) {
      this.tempFormGroup.get('value').addValidators(Validators.required);
    }
    this.addRequiredValidator();
    this.tempFormGroup
      .get('value')
      .valueChanges.pipe(debounceTime(250), distinctUntilChanged(), pairwise())
      .subscribe(([oldVal, newVal]) => {
        if (oldVal != null) {
          this.parentFormGroup.removeControl(oldVal);
        }

        if (newVal != null) {
          this.parentFormGroup.addControl(newVal, new FormControl(true));
        }
        this.addRequiredValidator();
      });
    this.setCurrentDropdownValue();
  }

  private addRequiredValidator() {
    if (this.currentConfig?.validators?.required) {
      if (this.tempFormGroup.get('value').value != null) {
        this.parentFormGroup.removeControl(this.id);
      } else {
        this.parentFormGroup.addControl(
          this.id,
          new FormControl(null, Validators.required),
        );
      }
    }
  }

  private async setCurrentDropdownValue() {
    this.getDropdownValues(this.currentConfig);
    const currentValue = this.getCurrentValueInParentForm();
    this.tempFormGroup.get('value').setValue(currentValue);
  }

  getDropdownValues(config: Config) {
    if (config.values == null) {
      this.commonUtils.getDropdownValues(
        config,
        this.form?.value || {},
        this.matSelect,
      );
    }
  }

  getValues() {
    const dropdownId = this.currentConfig.dropdownID;
    return (
      (dropdownId
        ? map(this.currentConfig.values, dropdownId)
        : this.currentConfig.values) || []
    );
  }

  getCurrentValueInParentForm() {
    let currentValue = null;
    const values = this.getValues();
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      if (this.parentFormGroup.get(value)) {
        currentValue = value;
        break;
      }
    }
    return currentValue;
  }
}
